/**
 * @generated SignedSource<<7b407e3ad609ac5ef23f48875b304f5d>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type PoiSelect_data$data = {
  readonly pois: {
    readonly edges: ReadonlyArray<{
      readonly node: {
        readonly id: string;
        readonly name: string;
      };
    }>;
  };
  readonly " $fragmentType": "PoiSelect_data";
};
export type PoiSelect_data$key = {
  readonly " $data"?: PoiSelect_data$data;
  readonly " $fragmentSpreads": FragmentRefs<"PoiSelect_data">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "PoiSelect_data",
  "selections": [
    {
      "alias": null,
      "args": [
        {
          "kind": "Literal",
          "name": "first",
          "value": 2147483647
        }
      ],
      "concreteType": "PoiConnection",
      "kind": "LinkedField",
      "name": "pois",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "concreteType": "PoiEdge",
          "kind": "LinkedField",
          "name": "edges",
          "plural": true,
          "selections": [
            {
              "alias": null,
              "args": null,
              "concreteType": "Poi",
              "kind": "LinkedField",
              "name": "node",
              "plural": false,
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "id",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "name",
                  "storageKey": null
                }
              ],
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ],
      "storageKey": "pois(first:2147483647)"
    }
  ],
  "type": "Query",
  "abstractKey": null
};

(node as any).hash = "ca7ade9089ca5e118b39859557fb5b24";

export default node;
